export const GDPRCountries = [
  'AD',
  'AI',
  'AT',
  'AW',
  'AX',
  'BE',
  'BG',
  'BL',
  'BM',
  'CW',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FK',
  'FR',
  'GB',
  'GF',
  'GG',
  'GI',
  'GL',
  'GP',
  'GR',
  'GS',
  'HR',
  'HU',
  'IE',
  'IO',
  'IT',
  'JE',
  'KY',
  'LI',
  'LT',
  'LU',
  'LV',
  'MC',
  'ME',
  'MF',
  'MQ',
  'MS',
  'MT',
  'NC',
  'NL',
  'PF',
  'PL',
  'PM',
  'PN',
  'PT',
  'RE',
  'RO',
  'SE',
  'SH',
  'SI',
  'SK',
  'SM',
  'SX',
  'TC',
  'TF',
  'VA',
  'VG',
  'WF',
  'YT',
];
